module.exports = __webpack_public_path__ + "img/videocall_white.04f83877.svg";